import React from 'react';
import { CssBaseline } from '@mui/material';
import { ErrorBoundary } from './ErrorBoundary';

const AppRoot: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  React.useEffect(() => {
    // Remove the server-side injected CSS.
    const jssStyles = global.document.getElementById('jss-server-side');

    if (jssStyles && jssStyles.parentNode) {
      jssStyles.parentNode.removeChild(jssStyles);
    }
  }, []);

  return (
    <React.Fragment>
      <CssBaseline />
      <ErrorBoundary>
        <React.StrictMode>
          {/*// @ts-ignore */}
          {children}
        </React.StrictMode>
      </ErrorBoundary>
    </React.Fragment>
  );
};

export { AppRoot };
